<template>
  <div>
    <HeadNav selectedLanguage="en" page="blog1" :gotodownload="gotodownload" :apk="apk" />
<div id="page" class="site grid-container container hfeed">
      <div id="content" class="site-content">
        <div id="primary" class="content-area">
          <main id="maincontent" class="site-main">
            <section id="section-1" class="section-content">
              <h1 class="section-1-blog-head">
                How to Install GB WhatsApp Safely
              </h1>

              <div class="lazy-picture-container writer-banner width-75" style="text-align: center;">
                <picture><img width="auto" height="auto" alt="Install GBWhatsApp" src="../assets/blog-3.webp">
                </picture>
              </div>
              <!-- <div class="is-vertical is-content-justification-center is-layout-flex wp-container-9 wp-block-buttons">
              <div class="wp-block-button">
                <a id="dl" class="wp-block-button__link wp-element-button" target="_blank" rel="dl noopener" @click="gotodownload()">Download GB WhatsApp</a>
              </div>
            </div> -->
              <h2 class="intro-title blog">
                How to Install GB WhatsApp Safely
              </h2>
              <p class="writter-content">
                There’s a reason why millions are switching to feature-rich messaging apps that go beyond the basics.
                One standout choice is <a href="https://gbmodshub.com/" class="jump-url">GB WhatsApp</a>,which enhances
                privacy settings, customizable themes, and expanded
                file-sharing options. If you’ve been wondering <strong>how to install GB WhatsApp</strong> and unlock
                these extra perks,
                this guide is your one-stop solution. <br>
                Below, we’ll walk you through every step—from downloading to setup—along with safety tips, best
                practices, and answers to frequently asked questions.
              </p>

              <h2 class="intro-title blog">
                Where to Download GB WhatsApp Safely
              </h2>
              <p class="writter-content">
                Before you can install GB WhatsApp, you need the APK file. <strong>GB WhatsApp isn’t available on Google
                  Play Store,</strong> so you must download it from a trusted source. Look for reputable third-party
                sites like APKMirror or official developer sites. <br>
                <strong>Quick Tips:</strong>
              <ul>
                <li> Avoid unknown sources or links sent via social media.</li>
                <li> Verify the APK version is up to date.</li>
                <li> Always scan the file with antivirus software before installation.</li>
              </ul>
              </p>
              <!--  -->
              <!-- <div class="lazy-picture-container writer-banner width-75" style="text-align: center;">
                <picture><img width="auto" height="auto" alt="what is GB WhatsApp" src="../assets/gb-seething.webp">
                </picture>
              </div>
              </p> -->
              <!--  -->

              <h2 class="intro-title blog">
                Step-by-Step GB WhatsApp Installation Process
              </h2>
              <p class="writter-content">
                Installing GB WhatsApp is easier than you think. Follow these basic steps:
              <ol>
                <li> <strong>Enable Unknown Sources</strong> on your Android device: <br>
                  Go to Settings > Security > Install unknown apps, and allow permission for your browser or file
                  manager.</li>
                <li> <strong>Download the GB WhatsApp APK</strong> from our website.</li>
                <li> <strong>Locate the APK file</strong> in your Downloads folder and tap to start the installation.
                </li>
                <li> <strong>Launch the app,</strong> agree to terms, and <strong>verify your phone number</strong> just
                  like you do on regular WhatsApp.</li>
                <li> <strong>Restore previous chats</strong> if prompted, or start fresh.</li>
              </ol>
              </p>
              <h2 class="intro-title blog">GB WhatsApp Features You’ll Love After Installation</h2>
              <p class="writter-content">
                Once you’ve installed GB WhatsApp, you'll discover several <a
                  href="https://gbmodshub.com/gb-whatsapp-features/" class="jump-url">GB WhatsApp features</a> that
                make it worth the switch:
              <ul>

                <li> <strong>Custom Themes:</strong> Personalize the interface to suit your style.</li>
                <li> <strong>Advanced Privacy Options:</strong> Hide double ticks, blue ticks, and even your online
                  status.</li>
                <li> <strong> Media Sharing Boost:</strong> Send up to 100 images at once and large video files.</li>
                <li> <strong>Message Scheduling:</strong> Plan and automate messages for any occasion.</li>
                <li> <strong>App Lock:</strong> Add extra security with a built-in lock feature.</li>
              </ul>
              </p>
              <h2 class="intro-title blog">Common Issues When Installing GB WhatsApp & How to Fix Them</h2>
              <p class="writter-content">
                Sometimes users face hiccups during installation. Here’s how to troubleshoot:
              <ul>
                <li> <strong>App not installing?</strong> Make sure unknown sources are enabled.</li>
                <li> <strong>Parse error?</strong> Check if the APK is compatible with your Android version.</li>
                <li> <strong>App crashing?</strong> Try clearing cache or reinstalling the latest version.</li>
                <li> <strong>Can’t verify number?</strong> Ensure your phone has a stable internet connection and the
                  correct SIM.</li>
              </ul>
              </p>
              <h2 class="intro-title blog">
                Is It Safe to Use GB WhatsApp? Let’s Discuss
              </h2>
              <p class="writter-content">
                Security and privacy are critical. GB WhatsApp is a third-party app and is <strong>not officially
                  endorsed by WhatsApp Inc.</strong> That means:
              <ul>
                <li> Your account might be temporarily banned by WhatsApp.</li>
                <li> Data security isn’t guaranteed since it's not end-to-end encrypted through official servers.</li>
                <li> <strong>Always use it with caution,</strong> back up data regularly, and consider using a secondary
                  number for extra safety.</li>
              </ul>
              </p>

              <h2 class="intro-title blog">FAQs</h2>
              <h3>Q1: Can I install GB WhatsApp alongside regular WhatsApp?</h3>
              <p>
                Yes, you can use both apps simultaneously if you register GB WhatsApp with a different phone number.
              </p>
              <h3>Q2: Do I need to root my phone to install GB WhatsApp?</h3>
              <p>
                No, GB WhatsApp works on both rooted and non-rooted Android devices.
              </p>
              <h3>
                Q3: Will I lose my chats from regular WhatsApp?
              </h3>
              <p>
                If you back up your chats in regular WhatsApp and restore them during GB WhatsApp installation, you
                won’t lose your data.
              </p>
              <h2 class="intro-title blog">Final Thoughts</h2>
              <p class="writter-content">
                Installing <strong>GB WhatsApp </strong> opens a world of possibilities that traditional WhatsApp doesn’t offer. From
                privacy controls to customization, it's perfect for users who want more control and style in their
                messaging experience. However, use it responsibly, and always stay informed about potential risks. <br>
                Whether you're a tech-savvy user or just curious about trying something new, this guide on <strong>how to install GB WhatsApp</strong> has you covered from start to finish.
              </p>
              <Carousel />
            </section>

          </main>
        </div>
      </div>
    </div>

    <div v-if="$global.isMobileDevice()" id="fixed-bottom-btn" class="fix-bottom-btn" @click="gotodownload()">
      Download GBWhatsapp APK
    </div>
  </div>
</template>

<script>
import '@/css/base.scss';
import HeadNav from '@/components/HeadNav.vue';
import Carousel from '@/components/Carousel.vue';
import doc from '@/documents/blogs.js';
export default {
  name: 'Home',
  components: {
    HeadNav,
    Carousel,
  },
  data() {
    return {
      pageName: 'home',
      selectedLanguage: 'en',
      doc: doc,
      showapk: false,
      apk: null,
      from: 'gb',
      filename: 'gb',
      relatedPosts: [
        {
          image: require('@/assets/uninstall-gbwhatsapp.webp'),
          title: 'Related Post Title 1',
          description: 'Brief description of the related post. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'
        },
        {
          image: require('@/assets/uninstall-gbwhatsapp.webp'),
          title: 'Related Post Title 2',
          description: 'Brief description of the related post. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'
        }
      ]
    };
  },
  mounted() {
    this.from = this.$global.GetQueryString('from') || this.from;
    this.filename = this.$global.GetQueryString('filename') || this.filename;
    console.log(this.$global.GetQueryString('from'));
    if (this.$global.GetQueryString('from')) {
      this.getAPK();
    } else {
      this.getOfficalApk();
    }
  },
  methods: {

    downloadfrom(reason) {
      this.download();
      this.$logEvent(`download_from_${reason}`, 'download');
      // window.location.href = `https://gbapp.pro?apps=gb&domain=gbwhatsapp.chat&appName=GB_gbwhatsapp.chat`;
    },
    getAPK() {
      this.$server
        .getAPPInfo({
          promotionChannel: this.from,
          promotionName: this.filename,
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            this.apk = res.data.apk;
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    getOfficalApk(type = 1, domain = null, appname = null) {
      this.$server
        .getOfficalApk({
          domain: domain || 'gbwhatsapp.chat',
          appName: appname || 'GB_gbwhatsapp.chat',
        })
        .then((res) => {
          console.log(res);
          if (res.code == 200) {
            if (type == 1) {
              this.apk = res.data.apk;
            }
            this.lastupdate = res.data.promotion.updateTime;
            this.votes = res.data.promotion.totalCount;
            this.rating = res.data.promotion.score;
            console.log('apk getted');
          } else {
            this.apk = process.env.VUE_APP_GBLINK;
          }
        });
    },
    gotodownload() {
      console.log(this.apk);
      // this.showapk = true
      if (this.apk) {
        this.$global.download(this.apk);
      }
    },
    jump(url) {
      window.location.href = url;
    },
    goto(page) {
      this.$router.push({
        name: `${this.selectedLanguage}-${page}`
      });
    }
  },
};
</script>
<style lang="scss" scoped>
$--group-option-flex: 0 calc(1 / 5) * 100% !default;

.blog1-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  /* 小屏幕左右边�?*/
}

.main-content {
  flex: 2;
  margin-right: 30px;
  background: #f7f7f7;
  padding: 20px;
  border-radius: 10px;
}

.related-posts {
  flex: 1;
  /* �?/3宽度 */
}

.blog1-container {
  display: flex;
  gap: 30px;
  /* 列间�?*/
  margin-top: 40px;
}

/* 文章主体样式 */
.blog-title {
  font-size: 2.5rem;
  margin-bottom: 15px;
  line-height: 1.2;
  font-weight: 700;
}

.author-info {
  display: flex;
  gap: 15px;
  font-size: 0.95rem;
  color: #666;
  margin-bottom: 20px;
}

.download-btn {
  padding: 20px;
  background-color: #025cd8;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  margin: 15px 0;
  font-size: 20px;
  display: inline-block;
}

.content-divider {
  border: 0;
  height: 1px;
  background-color: #eee;
  margin: 30px 0;
}

.article-content {
  line-height: 1.6;
  font-size: 1.05rem;
}

/* 相关文章样式 */
/* 优化后的相关文章样式 */
.related-post-item {
  display: flex;
  gap: 20px;
  padding: 15px 0;
  border-bottom: 1px solid #ccc;
  cursor: pointer;
}

.related-post-thumb {
  /* width: 100px; */
  height: 80px;
  object-fit: cover;
  border-radius: 4px;
  flex-shrink: 0;
}

.related-post-content {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.related-post-title {
  font-size: 1.1rem;
  margin-bottom: 8px;
  white-space: nowrap;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.related-post-desc {
  color: #666;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.related-post-divider {
  border: 0;
  border-top: 1px solid #eee;
  margin: 0;
}

.author {
  display: flex;
  /* padding: 40px; */
  max-width: 1000px;
  gap: 30px;
  margin: 30px auto;
  background: #f2fff6;
  border-radius: 12px;
  box-shadow: 0 2px 5px #ccc;
  /* align-items: center; */
}

.author-avatar {
  border-radius: 12px 0 0 12px;
  height: 100%;
}

.author-right-info {
  flex: 1;
  padding-right: 20px;

}

.author-olivia {
  padding: 20px 0;
}

/* 响应式调�?*/
@media (max-width: 992px) {
  .blog1-container {
    flex-direction: column;
    gap: 40px;
  }

  .author {
    flex-direction: column;
    padding: 10px;
    margin: 20px;
    gap: 0;
  }

  .main-content,
  .related-posts {
    flex: none;
    width: 100%;
  }
}
</style>